import { render } from "./CardInfoComponent.vue?vue&type=template&id=631d3c5e&scoped=true"
import script from "./CardInfoComponent.vue?vue&type=script&lang=js"
export * from "./CardInfoComponent.vue?vue&type=script&lang=js"

import "./CardInfoComponent.vue?vue&type=style&index=0&id=631d3c5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631d3c5e"]])

export default __exports__